export default __webpack_public_path__ + "static/media/LupaCapital.438f4812.svg";